<!-- Desktop -->
<ng-container *ngIf="isDesktop; else mobileView">
  <div class="cs-withdrawals">
    <div class="cs-withdrawals--payments" [style.height.px]="utils.getModalHeight('ion-modal--height')">
      <div class="cs-withdrawals--section-withdrawals background-color-light">
        <cs-transaction-item *ngFor="let type of withdrawals$ | async" [payment]="type"
          [paymentSelected]="currentWithdrawal" (navigate)="selectOption($event)" class="cs-trans">
        </cs-transaction-item>
      </div>
    </div>

    <div class="cs-withdrawals--content" [style.height.px]="utils.getModalHeight('ion-modal--height')">
      <div class="cs-withdrawals--content-container" #content [ngClass]="currentWithdrawal ? 'default' : 'clicked'">
        <!-- STEP 1 -->
        <div class="cs-withdrawals--section background-color-light p-4">
          <i class="cs-empty-icon codere-icon icon-take-coin color-dark p-bottom-2"></i>
          <ng-container
            *ngIf="globalVars.licenseType === licenseCOL && COLRegCashierTxtActive; else defaultCashierView">
            <h4 class="color-dark">{{'colombiaCashiertxt' | translate}}</h4>
            <h4 class="color-dark">{{'colombiaCashiertxt1' | translate}}</h4>
            <h4 class="color-dark">{{'colombiaCashiertxt2' | translate}}</h4>
          </ng-container>
          <ng-template #defaultCashierView>
            <h4 class="text-center color-dark">{{'cashiercashiertxt' | translate}}</h4>
          </ng-template>
        </div>

        <!-- STEP 2 -->
        <div *ngIf="checkSelectedWithdrawal()" class="cs-withdrawals--section text-center background-color-light">
          <div class="cs-withdrawals--container w-100 p-2">
            <div class="text-left"
              *ngIf="currentWithdrawal?.className === WMClassName.PAY_PAL && withdrawalsPaypalWarningActive">
              <div class="info-icon icon-info-container">
                <ion-icon class="iconinforeg icon-info" name="information-circle-outline"></ion-icon>
                <span class="color-dark info-text">
                  {{ 'withdrawalsPaypalWarningtxt' | translate }}
                </span>
              </div>
            </div>
            <div class="cs-withdrawals--img py-1" *ngIf="currentWithdrawal?.className !== WMClassName.CARD_SELECTION"
              [ngClass]="(currentWithdrawal?.className === WMClassName.LOCAL) ? 'cs-withdrawals--img-small' : 'cs-withdrawals--img'">
              <img src="assets/global/img/{{ currentWithdrawal?.image }}.png" alt="" />
            </div>
            <div *ngIf="currentWithdrawal?.className === WMClassName.CROWN_CASINO">
              <cs-crown-casino [isDeposit]="false"></cs-crown-casino>
            </div>

            <div class="cs-withdrawals--address mx-1" *ngIf="currentWithdrawal?.className === WMClassName.NEQUI">
              <span class="cs-withdrawals--phone-title my-1 w-100 color-score text-center">
                {{ 'withdrawalsNEQUIWarningtxt01' | translate }}
                <span class="cs-withdrawals--phone-title-bold"> ( {{ (userData$ | async)?.NumMovil }} ) </span>
                {{ 'withdrawalsNEQUIWarningtxt02' | translate }}
              </span>
            </div>

            <div class="cs-withdrawals--address mx-1" *ngIf="currentWithdrawal?.className === WMClassName.DAVIPLATA">
              <span class="cs-withdrawals--phone-title my-1 w-100 color-score text-center">
                {{ 'withdrawalsDAVIPLATAWarningtxt01' | translate }}
                <span class="cs-withdrawals--phone-title-bold"> ( {{ (userData$ | async)?.NumMovil }} ) </span>
                {{ 'withdrawalsDAVIPLATAWarningtxt02' | translate }}
              </span>
            </div>

            <div class="cs-withdrawals--transfer-mendoza-content"
              *ngIf="currentWithdrawal?.className === WMClassName.BANK_TRANSFER && globalVars.licenseType === licenseMDZ">
              <p class="cs-withdrawals--transfer-mendoza-text">{{ 'withdrawalstransfermendozatxt' | translate }}</p>
              <p class="cs-withdrawals--transfer-mendoza-text"
                [innerHTML]="'withdrawalstransfermendozaemail' | translate"></p>
            </div>

            <div class="cs-withdrawals--address mx-1" *ngIf="currentWithdrawal?.className === WMClassName.COINS_PAID">
              <span class="cs-withdrawals--address-title my-1 w-100 color-score text-center">Dirección</span>
              <form class="cs-withdrawals--address-amount background-color-white w-100">
                <input class="cs-withdrawals--address-input w-100 text-center m-unset color-dark" type="text"
                  [(ngModel)]="currentAddress" name="currentAddress" #input />
              </form>
            </div>

            <ng-container *ngIf="currentWithdrawal?.className === WMClassName.TRUE_LAYER">
              <!--TODO: revisar texto Spain-->
              <!-- <p class="instant-alert-text" *ngIf="isSpain">
                {{ 'withdrawalsTrueLayerWarningtxt' | translate }}
              </p> -->
              <div class="cs-withdrawals--address mx-1" *ngIf="trueLayerVerifiedAccountList?.length !== 0">
                <ion-list class="bg-list" *ngIf="trueLayerVerifiedAccountList?.length">
                  <span class="cs-withdrawals--accounts--text"> Selecciona una cuenta bancaria: </span>
                  <ion-item class="item-select">
                    <ion-label class="color-score">Selecciona una cuenta:</ion-label>
                    <ion-select [(ngModel)]="selectedAccount" (ionChange)="selectAccount($event)">
                      <ion-select-option value="newAccount"> Verificar nueva cuenta </ion-select-option>
                      <ion-select-option *ngFor="let account of trueLayerVerifiedAccountList, index as i"
                        value="{{account.iban}}">
                        {{account.iban | obfuscate}}
                      </ion-select-option>
                    </ion-select>
                  </ion-item>
                </ion-list>
              </div>
              <ng-container *ngIf="trueLayerVerifiedAccountList?.length === 0 || showVerificarButton">
                <span class="step1-truelayer--accounts--text">
                  {{ 'withdrawalsTrueLayerWarningtxt' | translate }}
                </span>
                <button (click)="verifyAccount()" class="cs-action-button background-color-secondary" tappable>
                  <span class="cs-action-button--text color-light"> {{ 'check' | translate }} </span>
                </button>
              </ng-container>

              <ng-container *ngIf="trueLayerVerifiedAccountList.length !== 0 && !showVerificarButton">
                <cs-calculator [options]="calculatorConfig" [paymentSelected]="currentWithdrawal"
                  [amount]="currentAmount" class="calculator-truelayer" [isActiveKeyboard]="isActiveKeyboard"
                  (amountSelected)="amountSelected($event)" (blockOperation)="handleCalculatorOperationBlocked($event)"
                  (setCustomAmount)="setCustomAmount($event)" (inputAmount)="inputAmount($event)">
                </cs-calculator>

                <button [disabled]="isActiveKeyboard || isOperationBlocked"
                  class="cs-action-button background-color-secondary" tappable (click)="checkStepWithdrawal()"
                  *ngIf="currentWithdrawal?.className === WMClassName.TRUE_LAYER">
                  <span class="cs-action-button--text color-light"> Cobrar </span>
                </button>
              </ng-container>
            </ng-container>

            <cs-calculator *ngIf="showCashier(true)" [options]="calculatorConfig" [paymentSelected]="currentWithdrawal"
              [amount]="currentAmount" [isActiveKeyboard]="isActiveKeyboard" (amountSelected)="amountSelected($event)"
              (blockOperation)="handleCalculatorOperationBlocked($event)" (setCustomAmount)="setCustomAmount($event)"
              (inputAmount)="inputAmount($event)">
            </cs-calculator>

            <cs-tpaga-info *ngIf="currentWithdrawal?.className === WMClassName.T_PAGA"> </cs-tpaga-info>

            <button [disabled]="isActiveKeyboard || isOperationBlocked"
              class="cs-action-button background-color-secondary" tappable (click)="checkStepWithdrawal()"
              *ngIf="showCashier(true)">
              <span class="cs-action-button--text color-light"> Cobrar </span>
            </button>

            <div *ngIf="currentWithdrawal?.className === WMClassName.HAL_CASH" class="cs-halCash-info" tappable
              (click)="showInfo('halCash')">
              <ion-icon name="help-circle-outline" class="color-score"></ion-icon>
              <span class="color-score cs-halCash-info--title p-left-1"
                [innerHTML]="'v2_infoHalCash' | translate"></span>
            </div>

            <div class="text-left"
              *ngIf="currentWithdrawal?.className === WMClassName.BANK_TRANSFER && withdrawalsBankTransferWarningActive">
              <div class="info-icon icon-info-container">
                <ion-icon class="iconinforeg icon-info" name="information-circle-outline"></ion-icon>
                <span class="color-dark info-text">
                  {{ 'withdrawalsBankTransferWarningtxt' | translate }}
                </span>
              </div>
            </div>

          </div>
        </div>

        <!-- STEP 3 -->
        <div *ngIf="!!currentWithdrawal && sectionStep === sectionStepEnum.third"
          class="cs-withdrawals--section background-color-light">
          <div [ngSwitch]="currentWithdrawal?.className" class="w-100 p-1">
            <cs-halcash-form *ngSwitchCase="WMClassName.HAL_CASH" [phoneNumber]="(userData$ | async)?.NumMovil"
              (formHalcashValue)="emitHalcashWithdrawal($event)" (inputInfo)="showInfo($event)">
            </cs-halcash-form>

            <cs-bank-transfer-form *ngSwitchCase="WMClassName.BANK_TRANSFER" [license]="globalVars?.licenseType"
              [userData]="(userData$ | async)" (formTransferValue)="emitTransferWithdrawal($event)"
              (inputInfo)="showInfo($event)">
            </cs-bank-transfer-form>

            <cs-bank-transfer-form *ngSwitchCase="WMClassName.ITAU" [license]="globalVars?.licenseType"
              [userData]="(userData$ | async)" (formTransferValue)="emitTransferWithdrawal($event)"
              (inputInfo)="showInfo($event)">
            </cs-bank-transfer-form>

            <cs-bank-transfer-form *ngSwitchCase="WMClassName.CLABE" [license]="globalVars?.licenseType"
              [banksEnabled]="globalVars.clabeBanksWithDrawalEnabled" [userData]="(userData$ | async)"
              (formTransferValue)="emitAstropayTransferWithdrawal($event)" (inputInfo)="showInfo($event)">
            </cs-bank-transfer-form>

            <cs-local-codere *ngSwitchCase="WMClassName.LOCAL" [license]="globalVars?.licenseType"
              [localConfig]="localConfig" (openCodereLocals)="openCodereLocals()"
              (cancelLocalCode)="cancelLocalCode($event)">
            </cs-local-codere>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- Mobile -->
<ng-template #mobileView>
  <div class="cs-withdrawals" #content>
    <!-- STEP 1 -->
    <div class="cs-withdrawals--section background-color-light">
      <cs-transaction-item *ngFor="let type of withdrawals$ | async" [payment]="type" (navigate)="selectOption($event)">
      </cs-transaction-item>
    </div>

    <!-- STEP 2 -->
    <div *ngIf="checkSelectedWithdrawal()" class="cs-withdrawals--section text-center background-color-light">
      <div class="text-left"
        *ngIf="currentWithdrawal?.className === WMClassName.PAY_PAL && withdrawalsPaypalWarningActive">
        <div class="info-icon icon-info-container">
          <ion-icon class="iconinforeg icon-info" name="information-circle-outline"></ion-icon>
          <span class="color-dark info-text">
            {{ 'withdrawalsPaypalWarningtxt' | translate }}
          </span>
        </div>
      </div>
      <!--Crown casino-->
      <div class="cs-deposit--container background-color-light w-100 p-1"
        *ngIf="currentWithdrawal?.className === WMClassName.CROWN_CASINO">
        <cs-crown-casino></cs-crown-casino>
      </div>
      <div class="cs-withdrawals--content w-100 fixed-height">
        <div class="cs-withdrawals--address mx-1" *ngIf="currentWithdrawal?.className === WMClassName.NEQUI">
          <span class="cs-withdrawals--phone-title my-1 w-100 color-score text-center">
            {{ 'withdrawalsNEQUIWarningtxt01' | translate }}
            <span class="cs-withdrawals--phone-title-bold"> ( {{ (userData$ | async)?.NumMovil }} ) </span>
            {{ 'withdrawalsNEQUIWarningtxt02' | translate }}
          </span>
        </div>

        <div class="cs-withdrawals--address mx-1" *ngIf="currentWithdrawal?.className === WMClassName.DAVIPLATA">
          <span class="cs-withdrawals--phone-title my-1 w-100 color-score text-center">
            {{ 'withdrawalsDAVIPLATAWarningtxt01' | translate }}
            <span class="cs-withdrawals--phone-title-bold"> ( {{ (userData$ | async)?.NumMovil }} ) </span>
            {{ 'withdrawalsDAVIPLATAWarningtxt02' | translate }}
          </span>
        </div>
        <!--TODO: No deberia aparecer-->
        <!-- <div
          class="cs-withdrawals--address mx-1"
          style="height: 100%"
          *ngIf="currentWithdrawal?.className === WMClassName.CROWN_CASINO"
        >
          <span [innerHTML]="'CrowCasinoWD' | translate"> </span>
        </div> -->

        <div class="cs-withdrawals--transfer-mendoza-content"
          *ngIf="currentWithdrawal?.className === WMClassName.BANK_TRANSFER && globalVars.licenseType === licenseMDZ">
          <p class="cs-withdrawals--transfer-mendoza-text">{{ 'withdrawalstransfermendozatxt' | translate }}</p>
          <p class="cs-withdrawals--transfer-mendoza-text" [innerHTML]="'withdrawalstransfermendozaemail' | translate">
          </p>
        </div>

        <div class="mx-1 cs-withdrawals--address" *ngIf="currentWithdrawal?.className === WMClassName.COINS_PAID">
          <span class="cs-withdrawals--address-title my-1 w-100 color-score text-center">Dirección</span>
          <form class="cs-withdrawals--address-amount background-color-white w-100">
            <input class="cs-withdrawals--address-input mx-1 background-color-white" type="text"
              [(ngModel)]="currentAddress" name="currentAddress" #input />
          </form>
        </div>
        <ng-container *ngIf="currentWithdrawal?.className === WMClassName.TRUE_LAYER">
          <!--TODO: revisar texto Spain-->
          <!-- <p class="instant-alert-text" *ngIf="isSpain">
            {{ 'withdrawalsTrueLayerWarningtxt' | translate }}
          </p> -->
          <div class="cs-withdrawals--address mx-1" *ngIf="trueLayerVerifiedAccountList !== 0">
            <span class="cs-withdrawals--accounts--text"> Selecciona una cuenta bancaria: </span>
            <ion-list class="bg-list" *ngIf="trueLayerVerifiedAccountList?.length">
              <ion-item class="item-select">
                <ion-select [(ngModel)]="selectedAccount" (ionChange)="selectAccount($event)"
                  aria-label="Selecciona una cuenta:">
                  <ion-select-option value="newAccount"> Verificar nueva cuenta </ion-select-option>
                  <ion-select-option *ngFor="let account of trueLayerVerifiedAccountList, index as i"
                    value="{{account.iban}}">
                    {{account.iban | obfuscate}}
                  </ion-select-option>
                </ion-select>
              </ion-item>
            </ion-list>
          </div>
          <ng-container *ngIf="trueLayerVerifiedAccountList.length === 0 || showVerificarButton">
            <span class="step1-truelayer--accounts--text">
              {{ 'withdrawalsTrueLayerWarningtxt' | translate }}
            </span>
            <button (click)="verifyAccount()" class="cs-action-button background-color-secondary" tappable>
              <span class="cs-action-button--text color-light"> {{ 'check' | translate }} </span>
            </button>
          </ng-container>

          <ng-container *ngIf="trueLayerVerifiedAccountList.length !== 0 && !showVerificarButton">
            <cs-calculator [options]="calculatorConfig" [paymentSelected]="currentWithdrawal" [amount]="currentAmount"
              class="calculator-truelayer" [isActiveKeyboard]="isActiveKeyboard"
              (amountSelected)="amountSelected($event)" (blockOperation)="handleCalculatorOperationBlocked($event)"
              (setCustomAmount)="setCustomAmount($event)" (setInputKeyboard)="setInputKeyboard()">
            </cs-calculator>
            <button [disabled]="isActiveKeyboard || isOperationBlocked"
              class="cs-action-button background-color-secondary" tappable (click)="checkStepWithdrawal()"
              *ngIf="currentWithdrawal?.className === WMClassName.TRUE_LAYER">
              <span class="cs-action-button--text color-light"> Cobrar </span>
            </button>
          </ng-container>
        </ng-container>
        <cs-calculator *ngIf="showCashier(true)" [options]="calculatorConfig" [paymentSelected]="currentWithdrawal"
          [amount]="currentAmount" [isActiveKeyboard]="isActiveKeyboard" (amountSelected)="amountSelected($event)"
          (blockOperation)="handleCalculatorOperationBlocked($event)" class="main-calculator"
          (setCustomAmount)="setCustomAmount($event)" (setInputKeyboard)="setInputKeyboard()">
        </cs-calculator>

        <cs-tpaga-info *ngIf="currentWithdrawal?.className === WMClassName.T_PAGA"> </cs-tpaga-info>

        <button [disabled]="isActiveKeyboard || isOperationBlocked" class="cs-action-button background-color-secondary"
          tappable (click)="checkStepWithdrawal()" *ngIf="showCashier(true)">
          <span class="cs-action-button--text color-light"> Cobrar </span>
        </button>

        <div *ngIf="currentWithdrawal?.className === WMClassName.HAL_CASH" class="cs-halCash-info" tappable
          (click)="showInfo('halCash')">
          <ion-icon name="help-circle-outline"></ion-icon>
          <span class="cs-halCash-info--title p-left-1" [innerHTML]="'v2_infoHalCash' | translate"></span>
        </div>

        <div class="text-left"
          *ngIf="currentWithdrawal?.className === WMClassName.BANK_TRANSFER && withdrawalsBankTransferWarningActive">
          <div class="info-icon icon-info-container">
            <ion-icon class="iconinforeg icon-info" name="information-circle-outline"></ion-icon>
            <span class="color-dark info-text">
              {{ 'withdrawalsBankTransferWarningtxt' | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- STEP 3 -->
    <div *ngIf="!!currentWithdrawal && sectionStep === sectionStepEnum.third"
      class="cs-withdrawals--section background-color-light">
      <div [ngSwitch]="currentWithdrawal?.className" class="w-100 p-1">
        <cs-halcash-form *ngSwitchCase="WMClassName.HAL_CASH" [phoneNumber]="(userData$ | async)?.NumMovil"
          (formHalcashValue)="emitHalcashWithdrawal($event)" (inputInfo)="showInfo($event)">
        </cs-halcash-form>

        <cs-bank-transfer-form *ngSwitchCase="WMClassName.BANK_TRANSFER" [license]="globalVars?.licenseType"
          [userData]="(userData$ | async)" (formTransferValue)="emitTransferWithdrawal($event)"
          (inputInfo)="showInfo($event)">
        </cs-bank-transfer-form>

        <cs-bank-transfer-form *ngSwitchCase="WMClassName.ITAU" [license]="globalVars?.licenseType"
          [userData]="(userData$ | async)" (formTransferValue)="emitTransferWithdrawal($event)"
          (inputInfo)="showInfo($event)">
        </cs-bank-transfer-form>

        <cs-bank-transfer-form *ngSwitchCase="WMClassName.CLABE" [license]="globalVars?.licenseType"
          [banksEnabled]="globalVars.clabeBanksWithDrawalEnabled" [userData]="(userData$ | async)"
          (formTransferValue)="emitAstropayTransferWithdrawal($event)" (inputInfo)="showInfo($event)">
        </cs-bank-transfer-form>

        <cs-local-codere *ngSwitchCase="WMClassName.LOCAL" [license]="globalVars?.licenseType"
          [localConfig]="localConfig" (openCodereLocals)="openCodereLocals()"
          (cancelLocalCode)="cancelLocalCode($event)">
        </cs-local-codere>
      </div>
    </div>
  </div>
  <custom-keyboard *ngIf="isActiveKeyboard && sectionStep === sectionStepEnum.second" [active]="isActiveKeyboard"
    [cashier]="true" (closeKeyBoard)="closeKeyBoard($event)" (press)="pressInputKeyBoard($event)"></custom-keyboard>
</ng-template>